import React from 'react';
import styles from './bebssuco.module.scss';
import Logo from './src/logo.png';
import InstagramIcon from '../../icons/instagramIcon.tsx';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';
import FoodMenuIcon from '../../icons/foodMenuIcon.tsx';

const BTN_TEXT = '#FFEBD6';

/** Ajuste para os links reais da marca */
const CATALOGO_URL = 'https://www.pinktech.com.br/menu/bebssuco';
const INSTAGRAM_URL = 'https://www.instagram.com/bebssuco/?utm_source=ig_web_button_share_sheet';
const WHATSAPP_NUMBER = '#';
// const WHATSAPP_NUMBER = '5517991442403';
const WHATSAPP_MSG = 'Olá! Vim pelo link na bio e gostaria de mais informações.';
const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MSG)}`;

const Bebssuco: React.FC = () => {
    return (
        <div className={styles.bebssuco}>
            <div className={styles["body-thunder"]}>
                <div className={styles["container-thunder"]}>
                    <div className={styles.profileStack}>
                        <img
                            className={styles.logoImage}
                            src={Logo}
                            alt="Beb's Suco — sucos naturais"
                            decoding="async"
                        />
                        <div className={styles.links}>
                            <a
                                href={CATALOGO_URL}
                                className={`${styles.linkButton} ${styles.linkButtonCatalog}`}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <span className={styles.linkIcon} aria-hidden>
                                    <FoodMenuIcon height="24" color={BTN_TEXT} />
                                </span>
                                <span className={styles.linkLabel}>FAÇA SEU PEDIDO</span>
                            </a>
                            <a
                                href={WHATSAPP_URL}
                                className={`${styles.linkButton} ${styles.linkButtonWhatsapp}`}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <span className={styles.linkIcon} aria-hidden>
                                    <WhatsappIcon height="28" color={BTN_TEXT} />
                                </span>
                                <span className={styles.linkLabel}>WHATSAPP</span>
                            </a>
                            <a
                                href={INSTAGRAM_URL}
                                className={`${styles.linkButton} ${styles.linkButtonInstagram}`}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <span className={styles.linkIcon} aria-hidden>
                                    <InstagramIcon height="24" color="#F37C14" />
                                </span>
                                <span className={styles.linkLabel}>INSTAGRAM</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Bebssuco;
